export const currencies = [
  { name: 'USD', symbol: '$' },
  { name: 'GBP', symbol: '£' },
  { name: 'EUR', symbol: '€' },
];

export default currencies;
